import { Component, h, createRef } from 'preact';
import cx from 'classnames'
import { debounce } from 'lodash-es';

import { RequestState, REQUEST_IN_PROGRESS, REQUEST_SUCCESS, REQUEST_FAILED } from '../../../../types/request-state.model';
import { ListResponse, Location, LocationFilterItem } from '../../../../types';
import { locationService } from '../../../utils/location.service';

interface LinearLocationSearchProps {
  disabled?: boolean;
  placeholder?: string;

  location?: LocationFilterItem;
  searchString: string;

  onInput: (input: string) => void;
  onLocationChange?: (location: LocationFilterItem) => void;
}

interface LinearLocationSearchState {
  requestState?: RequestState;
  locations?: ListResponse<LocationFilterItem>;
  areSearchResultsVisible?: boolean;
}

export class LinearLocationSearch extends Component<LinearLocationSearchProps, LinearLocationSearchState> {
  containerRef = createRef<HTMLDivElement>();

  onSearchExecute = debounce(async (search) => {
    try {
      this.setState({ requestState: REQUEST_IN_PROGRESS });
            
      const response = await locationService.filterLocation(search);
      this.setState({
        locations: response.data,
        requestState: REQUEST_SUCCESS,
        areSearchResultsVisible: true
      });
    } catch (ex) {
      this.setState({ requestState: REQUEST_FAILED });
    }
  }, 500);

  onSearchInputChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const searchString = target.value;

    if (this.props.onInput) {
      this.props.onInput(searchString);
    }

    this.onSearchExecute(searchString);
  }

  onResultClick(location: LocationFilterItem) {
    this.setState({ areSearchResultsVisible: false });

    if (this.props.onLocationChange) {
      this.props.onLocationChange(location);
    }
  }

  createResultItem(member: LocationFilterItem, index: number) {
    let displayLabel: string;
    const label = member.label || member.area || member.city;

    return (
      <p onClick={() => this.onResultClick(member)}>
        { member.label }
      </p>
    )
  }

  checkClick = (event) => {
    // click is outside
    const container = this.containerRef.current;

    if (container && !container.contains(event.target)) {
      this.setState({
        areSearchResultsVisible: false
      });
    }
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.checkClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.checkClick, false);
  }

  getResultsSection(props: LinearLocationSearchProps, state: LinearLocationSearchState) {
    if (state.requestState === REQUEST_SUCCESS) {
      const locations = state.locations.results;

      if (locations) {
        return (
          <div className={cx('hi-location-search-box__results', {active : state.areSearchResultsVisible})}>
            { state.locations.results.map((member, i) => this.createResultItem(member, i)) }
          </div>
        );
      }
    }
  }

  render(props: LinearLocationSearchProps, state: LinearLocationSearchState) {
    return (
      <div className="hi-location-search-box" ref={ this.containerRef }> 
        <input 
          disabled={ props.disabled }
          className={ cx('hi-location-search-box__input form-control') } 
          type="text"
          placeholder={ props.placeholder || 'Search by city, neighborhood, or building' }
          value={ props.searchString }
          onInput={ event => this.onSearchInputChange(event) }
        />
        <span className="hi-location-search-box__icon">
          <i className="fas fa-search"></i>
        </span>
        { this.getResultsSection(props, state) }
      </div>
    );
  }
}
